<script context="module">
    import {writable} from "svelte/store";
    import {uuid} from "../Database.svelte";
    import {tick} from 'svelte';

    let Confirmations = writable([]);

    let evt;

    export async function confirm(message, is_alert, opts = {}) {
        let confirmation;
        return new Promise(async (resolve, reject) => {
            let handleEscape = (e) => {
                if (e.key == "Escape") {
                    reject();
                }
            }

            confirmation = {
                id: uuid(),
                message: message,
                save: resolve,
                cancel: reject,
                handleEscape,
                is_alert,
                opts
            }
            Confirmations.update((c) => [...c, confirmation]);

            await tick();

            document.querySelector(`#confirmation-${confirmation.id} .button.is-success`).focus();
        }).finally(() => {
            Confirmations.update((c) => c.filter((con) => con !== confirmation))
        })
    }
</script>

{#each $Confirmations as confirm (confirm.id)}
    <div class="modal is-active" id="confirmation-{confirm.id}" on:keydown="{confirm.handleEscape}">
        <div class="modal-background" on:click={confirm.cancel}></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">
                    {#if confirm.opts.title}
                        {confirm.opts.title}
                    {:else if confirm.is_alert}
                        Alert!
                    {:else}
                        Are you sure?
                    {/if}
                </p>
                <button class="delete" aria-label="close" on:click={confirm.cancel}></button>
            </header>
            <section class="modal-card-body">
                <p class="is-size-4">{confirm.message}</p>
            </section>
            <footer class="modal-card-foot">
                {#if confirm.is_alert}
                    <button class="button is-success" on:click={confirm.save}>Okay</button>
                {:else}
                    <button class="button" on:click={confirm.cancel}>
                        {#if confirm.opts.no_button_text}
                            {confirm.opts.no_button_text}
                        {:else}
                        No
                        {/if}
                    </button>
                    <button class="button is-success" on:click={confirm.save}>
                        {#if confirm.opts.yes_button_text}
                            {confirm.opts.yes_button_text}
                        {:else}
                            Yes
                        {/if}
                    </button>
                {/if}
            </footer>
        </div>
    </div>
{/each}

<style>
    .modal-card-foot {
        justify-content: flex-end;
    }

    .modal {
        z-index: 999;
    }
</style>